import './WorkflowPage.scss';

import React from 'react';
import PropTypes from 'prop-types';
/* eslint no-unused-vars: [2, { "varsIgnorePattern": "[CssConstants]" }] */
import CssConstants from 'style/CssConstants';
import Toaster from 'components/layout/shared/toaster/Toaster';
import StatefulFooter from 'components/layout/shared/StatefulFooter';
import WorkflowNavBar from 'components/nav/WorkflowNavBar';
import AjaxErrorBoundary from 'components/shared/ErrorBoundary/AjaxErrorBoundary';

class WorkflowPage extends React.Component {
  static propTypes = {
    backgroundClassName: PropTypes.string,
    centerNav: PropTypes.object,
    children: PropTypes.node,
    enableDesktopAvatar: PropTypes.bool,
    /* Used to ensure the mobile workflow navbar height and
    style for a specific workflow regardless of screen size.
    /* Ex. Forcing a specific workflow on a tablet whose mobile
    breakpoint is triggered depending on device orientation */
    forceMobileWorkflow: PropTypes.bool,
    leftNav: PropTypes.object,
    rightNav: PropTypes.object,
    showFooter: PropTypes.bool,
    hideNavBar: PropTypes.bool,
  };

  static defaultProps = {
    showFooter: false,
  };

  constructor(props) {
    super(props);
    this.state = { showToaster: false };
  }

  showLoading(text) {
    this.setState({ showToaster: true });
    this.refs.toaster.showLoading(text);
  }

  showSuccess(text, onDismiss) {
    this.setState({ showToaster: true });
    this.refs.toaster.showSuccess(text, onDismiss);
  }

  showConfirmation(text, onConfirm, confirmText, onDismiss, dismissText) {
    this.setState({ showToaster: true });
    this.refs.toaster.showConfirmation(text, onConfirm, confirmText, onDismiss, dismissText);
  }

  showFailed(text, onDismiss, dismissText) {
    this.setState({ showToaster: true });
    this.refs.toaster.showFailed(text, onDismiss, dismissText);
  }

  hideToaster() {
    this.setState({ showToaster: false });
    this.refs.toaster.hideToaster();
  }

  render() {
    const {
      backgroundClassName,
      centerNav,
      children,
      enableDesktopAvatar,
      forceMobileWorkflow,
      hideNavBar,
      leftNav,
      rightNav,
      showFooter,
    } = this.props;
    const { showToaster } = this.state;
    const rootWrapperClass = showToaster ? 'aa-wrapper-blur' : 'aa-wrapper';
    let workflowClassName = showFooter ? 'workflow-page-footer' : 'workflow-page';
    let contentClassName = forceMobileWorkflow ? 'content content-mobile' : 'content';

    if (hideNavBar) {
      contentClassName = 'content-no-padding';
    }

    if (backgroundClassName) {
      workflowClassName += ` ${backgroundClassName}`;
    }

    return (
      <div className="aa-workflow-page">
        <div className={rootWrapperClass}>
          <div className={workflowClassName}>
            { !hideNavBar && (
            <WorkflowNavBar
              leftNav={leftNav}
              rightNav={rightNav}
              centerNav={centerNav}
              enableDesktopAvatar={enableDesktopAvatar}
              forceMobileWorkflow={forceMobileWorkflow}
            />
            )}
            <div className={contentClassName}>
              <AjaxErrorBoundary>
                <div>
                  {children}
                </div>
              </AjaxErrorBoundary>
            </div>
            {showFooter ? <div className="push" /> : null}
          </div>
          {showFooter ? (
            <StatefulFooter backgroundColor={CssConstants.COLOR_AA_BACKGROUND} />
          ) : null}
        </div>
        <Toaster ref="toaster" />
      </div>
    );
  }
}

export default WorkflowPage;
